
/**
 * Fuente de contenidos destacados usada por la sección de highlights.
 *
 * Cada item aporta el texto base, la imagen y el destino del contenido.
 */
export const HIGHLIGHT_DATA = [
	{
		id: "highlights-item1",
		title: {
			default: "Hora del Cuento Bilingüe con René Colato Laínez",
			translationPath: "highlights.item1.title",
		},
		image: "/img/reading-resources/highlights/IMG4.png",
		videoUrl: 'https://www.youtube.com/watch?v=KTU_2IlSXTs',
	},
	{
		id: "highlights-item2",
		title: {
			default: "Taller de dibujo manga con Javier Rovella",
			translationPath: "highlights.item2.title",
		},
		image: "/img/reading-resources/highlights/IMG3.png",
		videoUrl: 'https://www.youtube.com/watch?v=Ws8ImcW1_AE&t=6254s',
	},
	{
		id: "highlights-item3",
		title: {
			default: "MakeMake te invita a Arrullos, rondas, nanas y canciones tradicionales en la promoción de lectura",
			translationPath: "highlights.item3.title",
		},
		image: "/img/reading-resources/highlights/IMG2.png",
		videoUrl: 'https://www.youtube.com/live/6jQ11TPZPOg?si=7yB2zutPB631j3RI',
	},
	{
		id: "highlights-item4",
		title: {
			default: "MakeMake te invita a Bilingual Storytime at your biblioteca",
			translationPath: "highlights.item4.title",
		},
		image: "/img/reading-resources/highlights/IMG1.png",
		videoUrl: 'https://www.youtube.com/live/1kwglR1Ue5Y?si=S2hONupht1o06ogs',
	},
];

export const HIGHLIGHTS_CHANNEL_URL = "https://www.youtube.com/channel/UCAGRlTJB3fUDRfkVRPVNdzQ";
